"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("@fluentui/react");
exports.LayoutCommandButton = function (props) {
    var disabled = props.disabled, icon = props.icon, onClick = props.onClick, href = props.href, menuProps = props.menuProps, menuAs = props.menuAs, allowDisabledFocus = props.allowDisabledFocus, name = props.name;
    return (react_1.default.createElement(react_2.ActionButton, { disabled: disabled, iconProps: { iconName: icon }, role: "menuitem", onClick: onClick, href: href, menuProps: menuProps, menuAs: menuAs, allowDisabledFocus: allowDisabledFocus }, name));
};
//# sourceMappingURL=LayoutCommandButton.js.map